import { takeLatest, put, call, select } from 'redux-saga/effects';
import find from 'lodash/find';
import { updateCartItem } from 'yoda-interfaces/lib/Cart/CartApi';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import { digitalAnalyticsData } from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import ItemCountActions from 'yoda-site-components/lib/actions/ItemCountAction';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import {
    CART_ITEM_QUANTITY_UPDATE_REQUEST,
    CART_DETAILS_GET_REQUEST,
} from '../actionTypes/CartActionTypes';
import { updateCartItemInit } from '../actions/CartItemsAction';

// DA => function which will give me orderItems
export const orderItems = (state) => state.orderItems;

function* itemQuantityUpdateSaga(actionParam) {
    const action = actionParam;
    // DA => get item previous quantity while updating item quantity
    const findItemData = yield select(orderItems);
    let getModifiedItem = find(findItemData, { id: action.payload.id });
    const parentItem = getModifiedItem;
    const productId = parentItem ? parentItem.id : action.payload.id;
    const isChildItemUpdate = !!action.payload.serviceType;
    const calculateProductPrevQuantity = getModifiedItem
        ? getModifiedItem.quantity
        : action.payload.params.quantity;
    getModifiedItem =
        getModifiedItem && getModifiedItem.childItems && action.payload.serviceType
            ? find(getModifiedItem.childItems, { type: action.payload.serviceType })
            : getModifiedItem;
    let productMaxQuantityReached = 'no';
    // Don't fire cart update DA on edit silver item on cart page slide over.
    if (action.payload && !action.payload.interstitial) {
        const productPrevQuantity = isChildItemUpdate
            ? getModifiedItem.sku.quantity
            : calculateProductPrevQuantity;
        const selectedDeliveryOption = find(getModifiedItem.deliveryOptions, { selected: true });
        let itemQuantityUpdate = {};
        if (
            selectedDeliveryOption &&
            selectedDeliveryOption.inventory &&
            selectedDeliveryOption.inventory.quantity
        ) {
            productMaxQuantityReached =
                action.payload.params.quantity === selectedDeliveryOption.inventory.quantity
                    ? 'yes'
                    : 'no';
            itemQuantityUpdate = {
                cartUpdate: {
                    productId,
                    productPrevQuantity,
                    productMaxQuantityReached,
                    serviceType: action.payload.serviceType,
                },
            };
        } else {
            itemQuantityUpdate = {
                cartUpdate: {
                    productId,
                    productPrevQuantity,
                    productMaxQuantityReached,
                    serviceType: action.payload.serviceType,
                },
            };
        }
        // DA <= adding productPrevQuantity to redux store. We will need this for Analytics
        yield put(digitalAnalyticsData(itemQuantityUpdate));
    }

    yield put(updateCartItemInit(action.payload.id));
    action.payload.errorHandler = {
        errorComponent: 'CART_SECTION',
        context: 'CART',
    };
    const result = yield call(FactorySaga, updateCartItem, action);
    if (result.isSuccess) {
        yield put(ItemCountActions.updateItemCountAction());
        const deliveryChangedItems = result.response.headers.get('x-item-delivery-changed');
        if (action.payload && !action.payload.interstitial) {
            // DA ==> sending a payload to know once item quantity update and get cart is success, trigger an event
            yield put({
                type: CART_DETAILS_GET_REQUEST,
                payload: 'ITEM_QUANTITY_UPDATE',
                auroraHeaders: deliveryChangedItems,
                productId: getModifiedItem ? getModifiedItem.id : action.payload.id,
                requestType: 'UPDATE_QUANTITY',
            });
        } else {
            yield put({ type: CART_DETAILS_GET_REQUEST, requestType: 'UPDATE_QUANTITY' });
        }
        LocalStorage.setData('TOTAL_EXCEEDED_ERROR', 0, true);
    } else {
        yield put(showGlobalLoader(false));
    }
}

const watchItemQuantityUpdate = function* watchItemQuantityUpdate() {
    yield takeLatest(CART_ITEM_QUANTITY_UPDATE_REQUEST, itemQuantityUpdateSaga);
};
watchItemQuantityUpdate.sagaName = 'watchItemQuantityUpdate';

export default watchItemQuantityUpdate;
